import { __decorate } from "tslib";
import { Pipe } from "@angular/core";
import { DatePipe } from "@angular/common";
import memo from "memo-decorator";
let SaLongDatePipe = class SaLongDatePipe extends DatePipe {
    transform(value, args) {
        if (!value) {
            return "";
        }
        return super.transform(value, "yyyy/MM/dd HH:mm");
    }
};
__decorate([
    memo()
], SaLongDatePipe.prototype, "transform", null);
SaLongDatePipe = __decorate([
    Pipe({
        name: "saLongDate"
    })
], SaLongDatePipe);
export { SaLongDatePipe };
